module.exports = __webpack_public_path__ + "static/Hexomatic-robot-graphic-bc8c4852556bdf442fd80fe06374e871.svg";